import Select from "./select";
import { ProjectStore } from "stores";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { ProjectTest } from "models/project";

interface Props {
  projectId: number;
  value: number;
  onChange: (id: number) => any;
  placeholder?: string;
  error?: boolean | string;
  label?: string;
}

const ProjectTestSelect = observer(
  ({
    projectId,
    value,
    onChange,
    placeholder,
    error,
    label,
  }: Props) => {
    const [tests, setTests] = useState<ProjectTest[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      if (projectId) {
        setLoading(true);
        ProjectStore.loadProjectTests(projectId)
          .then((data) => {
            setTests(data || []);
            setLoading(false);
          })
          .catch(() => {
            setTests([]);
            setLoading(false);
          });
      } else {
        setTests([]);
      }
    }, [projectId]);

    useEffect(() => {
      if (tests.length > 0 && value && !tests.find((t) => t.id === value)) {
        onChange(null);
      }
    }, [tests, value]);

    const options = tests.map((test) => ({
      label: test.name,
      value: test.id,
      file: test.file,
    }));

    const selectedTest = tests.find((t) => t.id === value);

    return (
      <Select
        className="project-test-select"
        placeholder={placeholder || "Select a test"}
        value={
          selectedTest
            ? {
                label: selectedTest.name,
                value: selectedTest.id,
                file: selectedTest.file,
              }
            : null
        }
        isClearable={!!placeholder && !!value}
        isSearchable={true}
        isLoading={loading}
        onChange={(option) => onChange(option?.value)}
        options={options}
        maxOptions={10}
        valueField="value"
        formatOption={(option) => (
          <div>
            {option.label}
            {option.file && <div className="info">{option.file}</div>}
          </div>
        )}
        error={error}
        label={label}
        disabled={!projectId}
      />
    );
  }
);

export default ProjectTestSelect;
